// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loading_loaderContent__2dJBw","loader":"Loading_loader__epDRi","spin":"Loading_spin__FFaYs","message":"Loading_message__b0eAU","readySoon":"Loading_readySoon__SsK3O"};